import get from 'lodash/get';
import baseState from './baseState';
import tuner from '../tuner';
import listenTimeLogger from '../loggers/listenTime';
import debug from '../debugger';

export function onError(e) {
  const currentStream = tuner.streamPlayer.getCurrentStream();
  const isBoostStation = get(currentStream, 'isBoostStation', false);
  debug.log('error while attempting to play', e);

  tuner.changeState(tuner.states.connecting, {
    playBoostExperience: isBoostStation,
  });
}

export function onPlay() {
  listenTimeLogger.setReportStartTime();
  tuner.changeState(tuner.states.playing);
}

export function onPositionChanged(data) {
  tuner.trigger(tuner.events.positionChanged, data);
}

var state = {
  name: 'paused',
  enter: function () {
    tuner.trigger(tuner.events.paused);
    tuner.streamPlayer.on(
      tuner.streamPlayer.events.positionChanged,
      onPositionChanged,
    );
  },
  play: function () {
    // if you are changing streams, you will no longer be in
    // paused and thus this will not fire. Goes to loading, etc first
    tuner.streamPlayer.play().then(onPlay).catch(onError);
  },
  seek: function (position) {
    tuner.streamPlayer.seek(position);
  },
  load: function (promise) {
    listenTimeLogger.resetOffsets();

    tuner.changeState(tuner.states.loading, promise);
  },
  exit: function () {
    tuner.streamPlayer.remove(
      tuner.streamPlayer.events.positionChanged,
      onPositionChanged,
    );
  },
};

export default {
  ...baseState,
  ...state,
};
